import React, { lazy, Suspense } from "react";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from "./view/layout/Header";
import Footer from "./view/layout/Footer";
import PaymentGateway from "./view/pages/PaymentGateway "
import PaymentCancelled from "./view/pages/PaymentCancelled"
import $ from "jquery";
import ResetPassword from "./view/layout/ResetPassword";
import FacilityData from "./components/FacilityData";
window.$ = window.jQuery = $;


// Lazy load controllers for better performance
const IndexController = lazy(() => import("./controller/IndexController"));
const AboutController = lazy(() => import("./controller/AboutController"));
const ContactController = lazy(() => import("./controller/ContactController"));
const FacilitiesController = lazy(() => import("./controller/FacilitiesController"));
const FacilitiesFiltterController = lazy(() => import("./controller/FacilitiesFiltterController"));
const PaymentController = lazy(() => import("./controller/PaymentController"));

// Users Router
const DashboardController = lazy(() => import('./controller/users/DashboardController'));
const FacilityDataController = lazy(() => import('./controller/FacilityDataController'));
const ProfileController = lazy(() => import('./controller/users/ProfileController'));
const ThankyouController = lazy(() => import('./controller/ThankyouController'))
const EditProfileController = lazy(()=> import('./controller/users/EditProfileController'))
const MessageController = lazy(() => import("./controller/users/MessageController"));
const HelpCenter = React.lazy(async () => {
  const module = await import("./controller/users/HelpAndSupport");
  return { default: module.HelpCenter }; 
});

const NewTicket = React.lazy(async () => {
  const module = await import("./controller/users/HelpAndSupport");
  return { default: module.NewTicket };
});

const ViewTicketDetails = React.lazy(async () => {
  const module = await import("./controller/users/HelpAndSupport");
  return { default: module.ViewTicketDetails };
});

const PrivateRoute = lazy(() => import("./model/PrivateRoute"))

const Faqs = React.lazy(() => import("./controller/CommonController").then(module => ({ default: module.Faqs })));
const Privacy = React.lazy(() => import("./controller/CommonController").then(module => ({ default: module.Privacy })));
const TermsAndConditions = React.lazy(() => import("./controller/CommonController").then(module => ({ default: module.TermsAndConditions })));
const Sitemap = React.lazy(() => import("./controller/CommonController").then(module => ({ default: module.Sitemap })));
const CusotmerSupport = React.lazy(() => import("./controller/CommonController").then(module => ({ default: module.CusotmerSupport })));


function App() {
  return (
    <Router>
      <Suspense>
        <Routes>
          <Route path="/" element={<IndexController />} />
          <Route path="/about-us" element={<AboutController />} />
          <Route path="/contact-us" element={<ContactController />} />
          <Route path="/facility-details" element={<FacilitiesController />} />
          <Route path="/faq" element={<Faqs />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="/sitemap" element={<Sitemap />} />
          <Route path="/customer-support" element={<CusotmerSupport />} />

          <Route path="/facility-show" element={<FacilitiesFiltterController />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          {/* 404 Page Route */}
          <Route path="*" element={<div>404 Page Not Found</div>} />

          {/* Payment route  */}
          {/* <Route path="/checkout" element={<PaymentController/>}/> */}
          <Route path="/Payment" element={<PaymentGateway key={Date.now()} />} />
          <Route path="/payment-cancelled" element={<PaymentCancelled />} />
          <Route path="/thankyou" element={<ThankyouController key={Date.now()}/>} />
          <Route element={<PrivateRoute />}>
            <Route path="/checkout" element={<PaymentController key={Date.now()} />} />
            <Route path="/dashboard" element={<DashboardController key={Date.now()} />} />
            <Route path="/profile" element={<ProfileController key={Date.now()}/>} />
            <Route path="/edit-profile" element={<EditProfileController key={Date.now()}/>} />
            <Route path="/message" element={<MessageController key={Date.now()} />} />
            <Route path ="/help-center" element={<HelpCenter key={Date.now()} />}/>
            <Route path ="/new-ticket" element={<NewTicket key={Date.now()} />}/>
            <Route path ="/ticket-details" element={<ViewTicketDetails key={Date.now()} />}/>
            <Route path="/facility-list" element={<FacilityDataController key={Date.now()} />} />
          </Route>
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
